import React from 'react';

export class BotAvatar extends React.Component {
   render() {
      return <div className='neo-icon-bot-agent'></div>;
   }
};
